import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Page titles for the create / edit screens, so a user always knows where they are. List pages keep their own
// title; these screens only had a section heading ("Lot Type Information", ...) or nothing at all.
// Create vs edit follows the address: an id in the path (/BankDetailsEdit/:id) or in the query (?lotTypeId=...).
const RoutePageTitle: FC = () => {
    const { pathname, search } = useLocation();
    const settings = useSelector((state: any) => state.settings?.settings);
    const auction = settings?.AuctionName || "Auction";
    const lot = settings?.LotName || "Lot";

    const query = new URLSearchParams(search);
    const has = (key: string) => !!query.get(key);
    const path = pathname.toLowerCase();

    const title = (() => {
        if (path === "/auctionadd") return `Create ${auction}`;
        if (path === "/auctionedit") return `Edit ${auction}`;
        if (path === "/lotadd") return `Create ${lot}`;
        if (path === "/lotedit") return `Edit ${lot}`;
        if (path === "/lottypeadd") return `Create ${lot} Type`;
        if (path === "/lottypeedit") return `Edit ${lot} Type`;
        if (path === "/documenttemplateadd") return "Create Document";
        if (path === "/documenttemplateedit") return "Edit Document";
        if (path === "/contactadd") return "Create Contact/Agent";
        if (path === "/contactedit") return "Edit Contact/Agent";
        if (path === "/useredit") return has("userId") ? "Edit User" : "Create User";
        if (path === "/venueedit") return has("venueId") ? "Edit Venue" : "Create Venue";
        if (path === "/bankdetailsadd") return "Create Bank Details";
        if (path.startsWith("/bankdetailsedit/")) return "Edit Bank Details";
        if (path === "/biddingcalculationsadd") return "Create Bidding Calculation";
        if (path.startsWith("/biddingcalculationsedit/")) return "Edit Bidding Calculation";
        if (path === "/incrementtableadd") return "Create Increment Table";
        if (path.startsWith("/incrementtableedit/")) return "Edit Increment Table";
        if (path === "/bulkuploadsadd") return "Create Bulk Upload";
        if (path.startsWith("/bulkuploadsedit/")) return "Edit Bulk Upload";
        if (path.startsWith("/action/")) return "Integration Action";
        return undefined;
    })();

    if (!title) return null;

    return (
        <div className="pb-route-title">
            <h1 className="pb-page-title">{title}</h1>
        </div>
    );
};

export default RoutePageTitle;
